<template>
  <b-container
    v-if="renderPage"
    :fluid="!hasPermission"
    class="text-light text-right"
  >
    <b-card v-if="hasPermission">
      <b-row class="mb-2">
        <b-col
          cols="12"
          md="8"
          align-v="start"
          fluid="md"
          class="mt-1"
        >
          <b-form-input
            v-model="search"
            placeholder="Buscar Cliente"
            type="text"
            class="form-control mb-2 mr-sm-2 mb-sm-0 "
          />
        </b-col>
        <b-col
          md="4"
          class="ml-auto mt-1"
        >
          <b-button
            variant="relief-info"
            to="/clientes/novo"
          >
            Novo Cliente
          </b-button>
        </b-col>
      </b-row>

      <div class="mt-1 text-light text-left ">
        <b-table
          responsive="xl"
          class="text-center"
          :fields="fields"
          :items="items"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="search"
          primary-key="id"
          @filtered="onFiltered"
        >

          <template #cell(actions)="row">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreHorizontalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>

                <b-dropdown-item
                  v-if="permissionBankSlip"
                  @click="linkGenerator('boleto', row.item.id)"
                >
                  <feather-icon
                    icon="UserIcon"
                    class="mr-50"
                  />
                  <span>Gerar Boleto</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="permissionRecurrence"
                  @click="linkGenerator('recorrencia', row.item.id)"
                >
                  <feather-icon
                    icon="LinkIcon"
                    class="mr-50"
                  />
                  <span>Gerar Recorrência</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-if="permissionPaymentLink"
                  @click="linkGenerator('venda-direta', row.item.id)"
                >
                  <feather-icon
                    icon="LockIcon"
                    class="mr-50"
                  />
                  <span>Gerar Link Pagamento</span>
                </b-dropdown-item>

                <b-dropdown-item @click="$router.push({path: `/clientes/editar/${row.item.id}`})">
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-50"
                  />
                  <span>Editar</span>
                </b-dropdown-item>

              </b-dropdown>
            </span>
          </template>
        </b-table>

        <div
          v-if="isEmpty"
          class="text-center text-dark mb-1 create-client text-center"
        >
          Você ainda não possui clientes cadastrados.
          <a
            href="/clientes/novo"
          >
            Clique aqui para criar um novo
          </a>
        </div>
      </div>

      <b-pagination
        v-if="renderTable"
        v-model="currentPage"
        align="center"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      />
    </b-card>

    <no-permission v-else />
  </b-container>
</template>

<script>
import {
  BTable,
  BButton,
  BFormInput,
  BCol,
  BDropdown,
  BDropdownItem,
  BRow,
  BCard,
  BContainer,
  BPagination,
} from 'bootstrap-vue'
import noPermission from '@/views/error/NoPermission.vue'
import { getAll } from '@/service/client/client'

import { callLoading } from '@/service/utilities/utilities'
import { getMerchantData } from '@/utils/get-merchant-data'

export default {
  components: {
    BTable,
    BButton,
    BFormInput,
    BPagination,
    BCol,
    BCard,
    BRow,
    BContainer,
    BDropdown,
    BDropdownItem,
    noPermission,
  },
  data() {
    return {
      auth: false,
      renderPage: false,
      search: '',
      perPage: 10,
      currentPage: 1,
      permissionRecurrence: false,
      permissionBankSlip: false,
      permissionPaymentLink: false,
      hasPermission: false,
      isEmpty: false,
      fields: [{
        key: 'name',
        label: 'Cliente',
      },
      {
        key: 'tax_id',
        label: 'Documento',
      },
      {
        key: 'email',
        label: 'E-mail',
      },
      {
        key: 'phone',
        label: 'Telefone',
      },
      {
        key: 'actions',
        label: 'Ações',
      },
      ],
      items: [],
      rows: null,
      renderTable: true,
      renderNotFound: false,
      permissions: [],
    }
  },
  beforeRouteLeave(to, from, next) {
    this.renderPage = false
    next()
  },
  async created() {
    callLoading(true)
    const permissions = getMerchantData().permissions.map(permission => +permission)

    this.permissionRecurrence = permissions.some(permissionCode => permissionCode === 5)
    this.permissionBankSlip = permissions.some(permissionCode => permissionCode === 4)
    this.permissionPaymentLink = permissions.some(permissionCode => permissionCode === 3)

    this.hasPermission = this.permissionRecurrence || this.permissionBankSlip || this.permissionPaymentLink
    await this.getClients()

    this.renderPage = true
    callLoading(false)
  },
  methods: {
    async getClients() {
      try {
        const response = await getAll()
        const { status } = response
        if (status === 200) {
          this.items = response.data.customers
          this.rows = response.data.customers.length
        } else if (status === 401) { this.isEmpty = true }
      } catch {
        this.$router.push('/error-404')
      }
    },
    onFiltered(filteredItems) {
      this.rows = filteredItems.length
      this.currentPage = 1
    },
    linkGenerator(type, id) {
      this.$router.push({
        path: `/novas-cobrancas/${id}`,
        query: {
          type,
        },
      })
    },
  },
}
</script>
<style scoped lang="scss">
  @import "@core/scss/vue/pages/client-style.scss";
</style>
